import groq from 'groq'
import { imageObject } from '../atoms/imageObject'
import { videoObject } from '../atoms/videoObject'
import { vimeoObject } from '../atoms/vimeoObject'
import { lottieObject } from '../atoms/lottieObject'

export const MediaObjectQuery = groq`
  MediaObject {
    media {
      select,
      ...,
      ${imageObject},
      ${videoObject},
      ${vimeoObject},
      ${lottieObject}
    }
  }
  `